import React, { useEffect, useRef, useContext } from "react";
import QRCode from "qrcode";
import { AppContext } from "../utilities/context";
import backQR from "../../public/assets/images/detailLogoBig.png";
import Button from "@mui/material/Button";

const QrRaw = () => {
  const context = useContext(AppContext);
  const canvasRef = useRef(null);
  const ringLink =
    process.env.REACT_APP_FRONT_URL +
    "/qr/" +
    (context.user ? context.user.hashId : "");

  useEffect(() => {
    const mainCanvas = canvasRef.current;
    const ctx = mainCanvas.getContext("2d");
    const canvasWidth = 870;
    const canvasHeight = 870;
    const qrSize = 300;

    mainCanvas.width = canvasWidth;
    mainCanvas.height = canvasHeight;

    const backgroundImage = new Image();
    backgroundImage.src = backQR;
    backgroundImage.onload = () => {
      ctx.drawImage(backgroundImage, 0, 0, canvasWidth, canvasHeight);

      const qrCanvas = document.createElement("canvas");
      QRCode.toCanvas(
        qrCanvas,
        ringLink,
        { width: qrSize, margin: 1 },
        (error) => {
          if (error) console.error(error);
          ctx.drawImage(
            qrCanvas,
            (canvasWidth - qrSize) / 2,
            (canvasHeight - qrSize) / 2
          );
        }
      );
    };
  }, [context.user]);

  const downloadQr = () => {
    const mainCanvas = canvasRef.current;
    if (mainCanvas) {
      const dataUrl = mainCanvas.toDataURL("image/png");
      const downloadLink = document.createElement("a");
      downloadLink.href = dataUrl;
      downloadLink.download = "QR_Code.png";
      downloadLink.click();
    }
  };

  return (
    <div>
      <div>
        <Button onClick={downloadQr} variant="outlined" color="primary">
          Download
        </Button>
      </div>
      <div>
        <canvas
          ref={canvasRef}
          style={{ display: "block", margin: "auto" }}
        ></canvas>
      </div>
    </div>
  );
};

export default QrRaw;
